import React from 'react'

export default function NotFound( { children } ) 
{
    return (
        <div className="not-found-text">{ children }</div>
    )
}
